import { EntityType } from './entities-type';

export const getEntityTypeLabel = (type: EntityType): string => {
  switch (type) {
    case EntityType.Institution:
      return 'Instituição de Ensino';
    case EntityType.PublicAgency:
      return 'Órgão Público';
    case EntityType.Company:
    default:
      return 'Empresa';
  }
};
